const TASK_SAVE = "TASK_SAVE";
const TASK_DELETE = "TASK_DELETE";
const TASK_DELETE_ALL = "TASK_DELETE_ALL";
const TASK_COMPLETE = "TASK_COMPLETE";
const TASK_COMPLETE_ALL = "TASK_COMPLETE_ALL";

export { TASK_SAVE, TASK_DELETE, TASK_DELETE_ALL,TASK_COMPLETE_ALL,TASK_COMPLETE };
